<template>


  <div>

      <Header
      :BackPage='false'
      :HideCart='true'
      :Title='carName'
      class="" 
      />



      <MainContainer>
     

        <CenteredCar
        :CarImg='this.carro.car_img'
        :CarModel='this.carro.car_name'
        :CarMotor='this.carro.car_motor'
        :CarYear='this.carro.ano.year'
        :CarMotorDescription='this.carro.car_brand'
        :CarId='this.carro.id'
        :RemoveGarage='RemoveGarage'
        class=''
        />
    
        <Modal/>

      <Loader
      :isLoading='haveAllProducts'
      />
     
        <ProductList
        :arrayProduct='this.allProducts'
        :linhaProdutos='this.title'
        :Loading='this.loader'
        :NotProduct='NotProduct'
        :UserId='this.userLocalId'
        />


      <div class='container fixed-bottom mt-5' v-show=' this.pre_cart_itens != 0'>
        <ButtonGoToCart
        class=' pulse'
        :Valor=' this.pre_cart_itens'
        :Itens='this.pre_cart_total '
        :ButtonFunction='this.goToCart'
        />
      </div>

        </MainContainer>

  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import CenteredCar from '../../components/Cards/CenteredCarCard'
import ProductList from '../../components/Product/ProductList'
import Header from '../../components/Header/Header'
import MainContainer from '../../components/Container/MainContainer'
import ButtonGoToCart from '../../components/Button/ButtonGoToCart'
import Modal from '../../components/Modal/Modal'
import Loader from '../../components/Load/LoadOverlay'

  export default {

    components: {
      ProductList,
      Header,
      MainContainer,
      CenteredCar,
      Modal,
      Loader,
      ButtonGoToCart,
    },
    data() {
      return {
        Pesquisar:true,
         loader: false,
         NotProduct: false,
         arrayCategorie: [],
         arrayProduct: [],
         carro : '',
         categoria: '',
         selected:'inital',
         title:' ',
         Loading:false
      }
    },
    computed: {
      
        ...mapState('product_car_list',['categories_produtos','product_by_categorie', 'quantity_product_by_categorie','all_products']),
        ...mapState('home',['car_selected']),
        ...mapState('pre_cart',['pre_cart_itens','pre_cart_total']),
        CarSelected(){
            return localStorage.getItem('car_selected')
        },
        carName () {
          return `Peças para ${this.carro.car_name}`
        },
        userLocalId (){
          return localStorage.getItem('id_user');
        },
        allProducts (){
          return this.all_products
        },
        haveAllProducts (){
          return this.all_products.length == 0
        },

        haveCart () {
          const text =  'Ver carrinho' + '(' + this.pre_cart_total + ')' + 'R$' +  this.pre_cart_itens
          return text
        },



    },
    methods: {
              ...mapActions('product_car_list',['ActionDeleteAllProductByCar','ActionGetProductByCar','ActionGetCategorias','ActionDeleteGarage','ActionGetProductByCategorias', 'ActionDeleteProductByCategorias','ActionSetChoicedProduct']),
              ...mapActions('home',['ActionLoadGarage']),
        async getEstrutura() {
            await this.ActionGetCategorias()
            this.arrayCategorie = this.categories_produtos
        },
        getCar(car) {    
            const garage = JSON.parse(localStorage.getItem('garage') || "[]");
            const find = garage.find(el => el.car == car)
            return find
        },
         async btnClick(id) {
          this.Pesquisar = !this.Pesquisar
          this.title = this.categoria_selecionada(id).name
          this.NotProduct = false
          this.loader = !this.loader
          await this.ActionGetProductByCategorias({car:this.CarSelected,categorie:id})
                if (this.quantity_product_by_categorie == 0) {
            this.NotProduct = true
          }
          this.arrayProduct = this.product_by_categorie
          this.loader = !this.loader
        },
        async newSearch() {
          await this.ActionDeleteProductByCategorias()
        },
        async newAllProductsByCar() {
          await this.ActionDeleteAllProductByCar()
        },
        scrollToTop() {
              window.scrollTo(0, 0);
        },
        addTitle (name) {
          console.log('click')
          this.title = name
        },
        categoria_selecionada (id) {
          return this.arrayCategorie.find(c => c.id ==id)
        },
        AtivaPesquisar(){
          this.Pesquisar = !this.Pesquisar
        },
        async RemoveGarage(id){
          this.Loading = !this.Loading
          await this.ActionDeleteGarage({id:id})
          this.Loading = !this.Loading
          this.$router.push({name:'home'})
          this.ActionLoadGarage({id:this.userLocalId})
        },
        goToCart(){
          this.$router.push({name:'cart_checkout'})
        }

    
    },
    created () {
       
        this.newSearch()
        this.newAllProductsByCar()
        if (this.CarSelected){
          if (this.product_by_categorie.lenght === undefined){
       
            this.arrayProduct = JSON.parse(sessionStorage.getItem('product_search') || "[]")
          }
          else{
      
            this.arrayProduct = this.product_by_categorie
          }
          this.carro = this.getCar(this.CarSelected)

          this.ActionGetProductByCar({car:this.carro.car})
      

   
        }
        else {
          alert('Nenhum carro foi selecionado.')
          this.$router.push({name:'home'})
          
        }

    },
  }
</script>

<style lang="css" scoped>

.btn-primary {
    color: var(--main-red-black);
    background-color: var(--main-white);
    border-color: var(--main-red-black);
}

.btn-outline-primary {
    color: var(--main-red-black);
    border-color: var(--main-red-black);
}

.title-list{
    font-size: 1rem;
  font-weight:900;
  padding-top:1%;
  font-family: 'Roboto',sans-serif;
  color:var(--main-red-black);
  text-transform:uppercase;
}

.btn-primary:focus,.btn-primary:active {
   outline: none !important;
   box-shadow: none;
}


.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .open>.dropdown-toggle.btn-primary {
    color: #fff;
    background-color: var(--main-red-black);
    /*set the color you want here*/
}

.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: var(--main-red-black);
    border-color: var(--main-red-black);
}

.list-group-item-warning {
    color: var(--main-red-black);
    background-color: var(--main-white);
    border: 0.019rem solid var(--main-red-light);
}
.list-group-item.active {
    z-index: 2;
    color: var(--main-white);
    background-color: var(--main-red-black);
    border-color: var(--main-red-black);
    border-style: solid;
}

.pulse {
  background: var(--main-red-black);
  cursor: pointer;
  box-shadow: var(--main-black);
  animation: pulse 1s infinite;
}
.pulse:hover {
  animation: none;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(15, 15, 15, 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(92, 6, 6, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(56, 4, 11, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(10, 10, 10, 0.4);
    box-shadow: 0 0 0 0 rgba(15, 15, 15, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(199, 7, 7, 0);
      box-shadow: 0 0 0 10px rgba(207, 7, 7, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(207, 11, 21, 0);
      box-shadow: 0 0 0 0 rgba(204, 44, 44, 0);
  }
}
</style>
